module.exports = __webpack_public_path__ + "12ee60ff21edb398bba355fd9868fe25.png";